<template>
	<v-dialog
		transition="dialog-top-transition"
		max-width="1500"
		v-model="isOpenPresetDialog"
		persistent
	>
		<v-card class="px-md-1">
			<v-card elevation="0">
				<v-row class="mx-4 pt-4">
					<v-col cols="4">
						<h1 class="pa-md-3 font-weight-light">
							Paquetes Frecuentes
						</h1>
					</v-col>
					<v-col cols="8">
						<v-text-field
							label="Buscar paquete"
							v-model="search"
							:append-icon="search ? 'mdi-close' : 'mdi-magnify'"
							class="pt-4"
						>

						</v-text-field>
					</v-col>
				</v-row>
				<v-divider class="mx-6"></v-divider>
				<!-- <v-item-group multiple"> -->
					<v-container>
						<v-row
							class="light mx-4"
							style="height: 580px; overflow-y: scroll"
						>
							<v-col
								v-for="(preset, index) in availablePackages"
								:key="index"
								md="6"
								cols="12"
							>
								<h1 class="font-weight-light primary--text">{{titles[index]}}</h1>
								<v-item-group>
									<v-item :key="index" v-slot="{}">
										<v-card
											:color="
												checkSelectedPackages(preset)
													? 'yellow darken-2'
													: 'primary darken-1'
											"
											class="d-flex flex-column pa-4"
											dark
											max-width="100%"
											elevation="0"
										>
											<v-card height="250px" :class="isLoading ? 'd-flex justify-center' : 'hide'" color="transparent"  elevation="0">
												<v-progress-circular
													class="align-self-center"
													:size="150"
													:width="3"
													:color="!checkSelectedPackages(preset)
														? 'yellow darken-2'
														: 'primary darken-1'"
													indeterminate
												><h3 class="font-weight-thin">Cargando</h3></v-progress-circular>
											</v-card>
											<v-card
												:class="isLoading ? 'hide' : ''"
												elevation="0"
												color="transparent"
												@click="changePackage(preset)"
											>
												<v-window v-model="onboarding[index]">
													<v-window-item
														v-for="(
															pack, packIndex
														) in preset"
														:key="`card-${packIndex}`"
													>
														<PresetCard
															class="px-4"
															:selected="
																checkSelectedPackages(
																	preset
																)
															"
															:preset="pack"
															:save="save"
														/>
													</v-window-item>
												</v-window>
											</v-card>
											<v-card-actions
												class="justify-space-between"
											>
												<v-btn text @click="prev(index)">
													<v-icon>mdi-chevron-left</v-icon>
												</v-btn>
												<v-item-group
													v-model="onboarding[index]"
													class="text-center"
													mandatory
												>
													<v-item
														v-for="n in preset.length"
														:key="`btn-${n}`"
														v-slot="{ active, toggle }"
													>
														<v-btn
															:input-value="active"
															icon
															@click="toggle"
														>
															<v-icon>mdi-record</v-icon>
														</v-btn>
													</v-item>
												</v-item-group>
												<v-btn text @click="next(index)">
													<v-icon>mdi-chevron-right</v-icon>
												</v-btn>
											</v-card-actions>
											<!-- <v-row no-gutters>
												<v-col cols="12">
													<PresetCard class="px-4" :selected="checkSelectedPackages(preset)" :preset="preset" :save="save"/>
												</v-col>
											</v-row> -->
										</v-card>
									</v-item>
								</v-item-group>
							</v-col>
						</v-row>
					</v-container>
				<!-- </v-item-group> -->
			</v-card>
			<v-card-actions class="justify-end">
				<v-btn :disabled="isLoading" color="primary" depressed @click="submitPackage()">
					Guardar
				</v-btn>
				<v-btn text color="red" @click="closePresetSelector()">
					Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapGetters, createLogger } from 'vuex';
import { clone } from '@/util/libUtil.js';
import PresetCard from './PresetCard.vue';
import Presets from '@/util/offerConfigurator/packagePresets/index.js';

export default {
	name: 'PresetBase',
	data: () => ({
		search: '',
		save: false,
		selectedPresets: [],
		onboarding: [],
		titles: [],
		isLoading: false,
	}),
	components: {
		PresetCard,
	},
	methods: {
		handler(preset, event) {
			this.changePackage(preset);
			if (!this.checkSelectedPackages(preset)) event.stopPropagation();
		},
		next(index) {
			this.onboarding[index] += 1
			this.$forceUpdate();
		},
		prev(index) {
			this.onboarding[index] -= 1
			this.$forceUpdate();
		},
		checkSelectedPackages(item) {
			return this.selectedPresets.some((another) => item == another);
		},
		changePackage(item) {
			let value = this.checkSelectedPackages(item);
			this.selectedPresets.splice(0, 1);

			if (!value) {
				this.selectedPresets.push(item);
			}
		},
		closePresetSelector() {
			this.$store.commit('configuradorOferta/isOpenPresetDialog', false);
			setTimeout(() => {
				this.save = false;
				this.clearFields();
			}, 1);
		},
		clearFields() {
			this.selectedPresets = [];
		},
		across(){
			let index = this.availablePackages.findIndex((another) => this.selectedPresets[0] == another);
			let preset = this.availablePackages[index];
			let finish = preset.length;
			
			for (let i = 0; i < preset.length; i++) {
				setTimeout(() => {
					this.onboarding[index] = i;
					this.$forceUpdate();	
				}, 1);			
			}

		},
		submitPackage() {
			this.isLoading = true;
			this.across();
			// wait until the animation is finished
			setTimeout(() => {
				this.save = true;
				this.$forceUpdate();
				setTimeout(() => {
					this.save = false;
					this.$forceUpdate();
					setTimeout(() => {
						this.closePresetSelector();
						
						setTimeout(() => {
							this.isLoading = false;
						}, 10);
					}, 1000);
				}, 2);
			}, 2);

			// this.closePresetSelector();
		},
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		cleanTitle(title) {
			// capitalize first letter
			return this.capitalizeFirstLetter(String(title).replace('_', ' ').replace('_and_', ' & ').replace('mas_', 'más '));
		},
		findText(title, search){
			let normalizedTitle = title.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
			let normalizedSearch = search.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

			return normalizedTitle.includes(normalizedSearch)
		}
	},
	computed: {
		isOpenPresetDialog: {
			get() {
				return this.$store.state.configuradorOferta.isOpenPresetDialog;
			},
			set(val) {
				this.$store.commit(
					'configuradorOferta/isOpenPresetDialog',
					val
				);
			},
		},
		availablePackages() {
			let processedPresets = [];
			let packages = [];
			this.titles = [];

			for (const key in Presets) {
				for (const preset in Presets[key]) {

					let item = Presets[key][preset];
					let title = this.cleanTitle(preset);

					if (
						((key
							.toLowerCase()
							.replaceAll(' ', '')
							.includes(
								this.selectedOperator.isp
									.toLowerCase()
									.replaceAll(' ', '')
							) &&
						key
							.toLowerCase()
							.includes(
								this.selectedOperator.segment.toLowerCase()
							))
							|| 
							(this.isAvatel &&
							key.toLocaleLowerCase().includes('avatel')))
							&& (!this.search || this.findText(title, this.search))
					) {
						packages = [];
						item.forEach((element) => {
							packages.push(element);
						});
						processedPresets.push(packages);
						this.titles.push(title);
					}
				}
			}

			return processedPresets;
		},
		...mapState('configuradorOferta', {
			selectedOperator: (state) => state.isp,
			isp: (state) => state.isp,
			paquete: (state) => state.paquete,
			promotions: (state) => state.promotions,
			paquetes: (state) => state.atencion.oferta.paquetes,
			atencion: (state) => state.atencion,
			configuratorType: (state) => state.configuratorType,
			principal: (state) =>
				state.atencion.oferta.paquetes.find(
					({ tipoLinea }) => tipoLinea == 'LINEA_PRINCIPAL'
				),
		}),
		...mapGetters('configuradorOferta', {}),
		...mapGetters('configuradorOferta', ['mainLine', 'iva']),
		...mapGetters('login', ['isAvatel']),
	},
	watch: {
		isOpenPresetDialog(val) {
			if (val) {
				this.onboarding	= [];
			}
		},
	},
};
</script>

<style lang="css" scoped>
	/* soft transition to hide */
	.hide {
		transition: all 0.5s ease-in-out;
		display: none;
	}
</style>